import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFirstName, selectLastName, selectDob, selectSSN4, selectSSN9, setFirstName, setLastName, selectTel, setDob, setSSN4, setSSN9, setTel, } from '../state/slices/slice-pii-data';
export var usePIIDataContext = function () {
    var dispatch = useDispatch();
    var firstName = useSelector(selectFirstName);
    var lastName = useSelector(selectLastName);
    var dob = useSelector(selectDob);
    var tel = useSelector(selectTel);
    var ssn4 = useSelector(selectSSN4);
    var ssn9 = useSelector(selectSSN9);
    var contextValue = React.useMemo(function () { return ({
        firstName: firstName,
        setFirstName: function (newFirstName) {
            return dispatch(setFirstName(newFirstName));
        },
        lastName: lastName,
        setLastName: function (newLastName) { return dispatch(setLastName(newLastName)); },
        dob: dob,
        setDob: function (newDob) { return dispatch(setDob(newDob)); },
        ssn4: ssn4,
        setSSN4: function (newSsn4) { return dispatch(setSSN4(newSsn4)); },
        ssn9: ssn9,
        setSSN9: function (newSsn9) { return dispatch(setSSN9(newSsn9)); },
        tel: tel,
        setTel: function (newTel) { return dispatch(setTel(newTel)); },
    }); }, [firstName, lastName, dob, ssn4, ssn9, tel, dispatch]);
    return contextValue;
};
